import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectStudentInsUpd } from "../../../redux/student/studentInsUpdSlice";
import { assertImagesUrl } from "../../../redux/common";

export function StudentInsUpdReview() {
    const studentInsUpd = useSelector(selectStudentInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={1} marginTop={1}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{studentInsUpd.student.name}</Typography>
            </Grid>
        </Grid>
        <Divider flexItem />
        <Grid container spacing={1} marginTop={1}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Apelido</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{studentInsUpd.student.nickname}</Typography>
            </Grid>
        </Grid>
        <Divider flexItem />
        <Grid container spacing={1} marginTop={1}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">e-mail</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{studentInsUpd.student.email}</Typography>
            </Grid>
        </Grid>
        <Divider flexItem />
        <Grid size={10}>
            <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                <Avatar
                    src={assertImagesUrl(studentInsUpd.student.url)}
                    alt={studentInsUpd.student.name}
                    sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                />
            </Box>
        </Grid>
        <Divider flexItem />

    </>;
}